<template>
  <div class="map-classes">
    <p class="text-left mx-2 mb-1">
      Selected Classes
      <span class="required"></span>
    </p>
    <v-autocomplete
      v-model="selectedRooms"
      :disabled="isLoading || disabled"
      :items="allRooms"
      chips
      color="blue-grey lighten-2"
      item-text="sections"
      hint="Start typing to search.."
      outlined
      return-object
      multiple
      class="rounded-input"
      @change="emitChanges"
    >
      <template v-slot:prepend-item>
        <v-list-item v-if="selectedRooms" ripple @click="toggleSelectAll">
          <v-list-item-action>
            <v-icon :color="selectedRooms.length > 0 ? 'primary' : ''">{{ icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Select All</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import endpoints from "@api/repository";
import api from "@api/index";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "MapClasses",
  props: ['rooms', 'disabled'],
  data() {
    return {
      allRooms: [],
      selectedRooms: [],
      // lockedRooms: [],
    };
  },
  computed: {
    ...mapGetters(["accessToken", "isLoading", "activeFeeSession"]),
    apiEssentials() {
      return {
        accessToken: this.accessToken,
        handleErrorFunction: this.handleApiErrors,
        setLoading: this.setLoading,
      };
    },
    
    selectedAllRooms() {
      return this.selectedRooms.length === this.allRooms.length;
    },
    selectedSomeRooms() {
      return this.selectedRooms.length > 0 && !this.selectedAllRooms;
    },
    icon() {
      if (this.selectedAllRooms) return "mdi-close-box";
      if (this.selectedFruits) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    // sends changes to parent
    async emitChanges() {
      this.$emit("changed", this.selectedRooms);
    },

    // isDisabled(item) {
      
    // },
    // queries all rooms from server
    async getAllRooms() {
      var response;
      var url = endpoints.getRooms + `?session=${this.activeFeeSession.academic_session.id}`;
      // var url = endpoints.getRooms;

      response = await api.handleApi({
        apiEssentials: this.apiEssentials,
        url: url,
        responseVar: response,
      });
      if (response) this.allRooms = response;
    },
    toggleSelectAll() {
      this.$nextTick(() => {
        if (this.selectedAllRooms) {
          this.selectedRooms = [];
        } else {
          this.selectedRooms = this.allRooms.slice();
        }
        this.$emit('changed', this.selectedRooms);
      });
    },
    async handleApiErrors(err) {
      console.log(err);
      this.setLoading(false);
    },
  },
  watch: {
    rooms() {
      if(this.rooms) this.selectedRooms = this.rooms;
      this.$emit("changed", this.selectedRooms);
    }
  },
  created() {
    this.getAllRooms(); 
  },
  
};
</script>

<style scoped>
.rounded-input {
  border-radius: 12px !important;
}
span.required::after {
  content: "*";
  color: red;
}   
</style>
      